import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import ms from 'ms';

import { type UUID } from '~/types/common';

import { queryKeysInvoiceReprocessing } from '../queryKeys';

import { fetchReprocessingInvoiceProcessStatus } from './fetchReprocessingInvoiceProcessStatus';

/**
 * React Query based custom hook for getting the status of an invoice process based on the process ID.
 * @param processId - The ID of the process to fetch the status for.
 * @param options - Optional configuration for the query.
 * @returns The query result containing the reprocessing invoice status.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoice/operation/get_process_status_invoice_process__process_id__status_get
 */
export const useQueryReprocessingInvoiceStatus = (
  processId: UUID,
  options?: Omit<UseQueryOptions<string>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<string>({
    enabled: Boolean(processId),
    queryFn: async () => fetchReprocessingInvoiceProcessStatus({ processId }),
    queryKey: queryKeysInvoiceReprocessing.getStatus(processId),
    refetchInterval: ms('30s'),
    ...options,
  });
};
